import React from 'react';

const InfoBlue = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M3.514 20.486c4.684 4.685 12.288 4.685 16.972 0 4.685-4.684 4.685-12.288 0-16.972-4.684-4.685-12.288-4.685-16.972 0-4.685 4.684-4.685 12.288 0 16.972Z"
        fill="#386C87"
      />
      <path
        d="M10.63 6.636c0-.748.627-1.372 1.373-1.372a1.39 1.39 0 0 1 1.373 1.372c0 .746-.605 1.373-1.373 1.373a1.36 1.36 0 0 1-1.373-1.373Zm.102 10.768v-6.93c0-.81.586-1.335 1.274-1.335.688 0 1.293.525 1.293 1.334v6.931c0 .81-.586 1.335-1.293 1.335s-1.274-.525-1.274-1.335Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoBlue;
